import { Link } from 'react-router-dom';

/** From/to parties, acknowledgements, conflicts with pledge or release. */
const rows = [
  {
    id: 'tr-3301',
    asset: 'A-18751',
    from: 'Custodian',
    to: 'SPV 2026-1 trustee',
    acknowledgements: 'Trustee ack · Sponsor pending',
    conflict: 'None',
    state: 'Pending decision',
  },
  {
    id: 'tr-3298',
    asset: 'A-18788',
    from: 'Custodian',
    to: 'River Trust',
    acknowledgements: 'Both parties acknowledged',
    conflict: 'Open pledge on related lot',
    state: 'Blocked',
  },
];

export function TransferQueuePage() {
  return (
    <div className="page-stack">
      <section className="card-shell p-5 sm:p-6">
        <p className="text-sm leading-relaxed text-evault-muted">
          Custody and rights-transfer logic: from/to parties, acknowledgements,
          and explicit conflicts with pledge or release state.
        </p>
      </section>

      <div className="table-shell overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[960px] border-collapse text-left text-xs sm:text-sm">
            <thead>
              <tr className="border-b border-evault-border bg-evault-surface/90">
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Transfer ref
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Asset
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  From
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  To
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Acknowledgements
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  Conflict check
                </th>
                <th className="px-4 py-3 font-semibold text-evault-muted">
                  State
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, ri) => (
                <tr
                  key={row.id}
                  className={`border-b border-evault-border last:border-b-0 ${
                    ri % 2 === 1 ? 'bg-evault-surface/40' : ''
                  }`}
                >
                  <td className="px-4 py-3.5 font-medium text-evault-teal">
                    {row.id}
                  </td>
                  <td className="px-4 py-3.5">
                    <Link
                      to={`/custodian/assets/${encodeURIComponent(row.asset)}`}
                      className="font-mono text-[11px] hover:underline sm:text-xs"
                    >
                      {row.asset}
                    </Link>
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/85">
                    {row.from}
                  </td>
                  <td className="px-4 py-3.5 text-umb-neutral-dark/85">
                    {row.to}
                  </td>
                  <td className="max-w-[200px] px-4 py-3.5 text-umb-neutral-dark/85">
                    {row.acknowledgements}
                  </td>
                  <td className="px-4 py-3.5">
                    <span
                      className={
                        row.conflict === 'None'
                          ? 'text-evault-vault-active'
                          : 'font-semibold text-red-600'
                      }
                    >
                      {row.conflict}
                    </span>
                  </td>
                  <td className="px-4 py-3.5 font-medium text-evault-teal-deep">
                    {row.state}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
